export const PAGE_CONTENT_MAX_WIDTH_LG = 1440;
export const PAGE_CONTENT_MAX_WIDTH_MD = 1136;
